import { CSSProperties } from 'react';

export const callPutTableContainer = (isCall: boolean): CSSProperties => ({
  position: 'relative',
  flex: 1,
  overflowY: isCall ? 'hidden' : 'auto',
});

export const callPutTableHeader: CSSFunction = () => ({
  position: 'sticky',
  top: 0,
  zIndex: 4,
});
